import { render } from "./Tenant_Prepayments.vue?vue&type=template&id=5bef0c7a"
import script from "./Tenant_Prepayments.vue?vue&type=script&lang=js"
export * from "./Tenant_Prepayments.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__